// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ScheduleOutlinedSvg from "@ant-design/icons-svg/es/asn/ScheduleOutlined";
import AntdIcon from '../components/AntdIcon';

var ScheduleOutlined = function ScheduleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ScheduleOutlinedSvg
  }));
};

ScheduleOutlined.displayName = 'ScheduleOutlined';
export default React.forwardRef(ScheduleOutlined);